import { useAnalytics } from "@codat/analytics";
import { LoginSetting } from "api/login";
import React from "react";
import Cookies from "universal-cookie";
import formatUrl from "utils/formatUrl";

import config from "config";

import { ThirdPartyLogo } from "../../../components/AuthPage/logos/thirdPartyLogo";
import styles from "./LoginByThirdParty.module.scss";

interface LoginByThirdPartyProps {
  loginSettings: LoginSetting[];
  inviteId?: string;
  redirectUrl?: string;
}

const providersWithAuth0Support = ["Microsoft", "Google"];

const ThirdPartyLoginButton: React.FC<{
  provider: LoginSetting;
  inviteId?: string;
  redirectUrl?: string;
}> = ({ provider, inviteId, redirectUrl }) => {
  const { sendEvent } = useAnalytics();

  const cookies = new Cookies();
  const useAuth0SocialLogin = cookies.get("UseAuth0SocialLogin") == "1";

  const url =
    providersWithAuth0Support.includes(provider.name) && useAuth0SocialLogin
      ? config.PORTAL_URL + "/sso/signin/" + provider.name.toLowerCase()
      : config.IDENTITY_SERVER_URL +
        formatUrl(
          "/external/:provider/login",
          {
            provider: provider.name,
          },
          {
            inviteId,
            returnUrl: redirectUrl,
          }
        );

  const onClick = () => {
    sendEvent("Third Party Login Button - Click", { provider: provider.name });
    window.location.replace(url);
  };

  return (
    <button
      className={styles.thirdPartyLoginButton}
      onClick={onClick}
      data-testid={`third-party-login-${provider.name}`}
    >
      <ThirdPartyLogo thirdParty={provider.name} />
      <span className={styles.thirdPartyLoginButtonText}>
        {"Sign in with " + provider.name}
      </span>
    </button>
  );
};

export const LoginByThirdParty: React.FC<LoginByThirdPartyProps> = ({
  loginSettings,
  inviteId,
  redirectUrl,
}) => {
  return (
    <div data-testid="third-party-providers">
      {loginSettings.map((provider) => (
        <ThirdPartyLoginButton
          key={provider.name}
          provider={provider}
          inviteId={inviteId}
          redirectUrl={redirectUrl}
        />
      ))}
    </div>
  );
};
